import { defineMessages } from 'react-intl'

const translations = defineMessages({
  title: {
    defaultMessage: 'Create Subscription',
    id: 'msp.subscription_form.header.title'
  },
  titleEdit: {
    defaultMessage: 'Edit Subscription',
    id: 'msp.subscription_form.header.title.edit'
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'msp.subscription_form.button.cancel'
  },
  create: {
    defaultMessage: 'Create',
    id: 'msp.subscription_form.button.create'
  },
  edit: {
    defaultMessage: 'Confirm',
    id: 'msp.subscription_form.button.edit'
  },
  success: {
    defaultMessage: 'Subscription got created successfully',
    id: 'msp.subscription_form.msg.success'
  },
  successEdit: {
    defaultMessage: 'Subscription got edited successfully',
    id: 'msp.subscription_form.msg.success.edit'
  },
  minTeaBoxes: {
    defaultMessage:
      'Your subscription must contain at least 6 boxes of tea. Please update your order to meet the minimum requirement.',
    id: 'msp.subscription_form.button.minTeaBoxes'
  }
})

export default translations
